export default {
  ARCHIVED: 'Arhivēts',
  NEW: 'JAUNS',
  NEW_PASSWORD: 'Ievadiet jaunu paroli',
  REPEAT_NEW_PASSWORD: 'Atkārtojiet jauno paroli',
  PASSWORD_IS_REQUIRED: 'Parole ir obligāta',
  PASSWORDS_MUST_MATCH: 'Parolēm jāsakrīt',
  PASSWORD_CHANGED_SUCCESSFULLY: 'Parole veiksmīgi nomainīta',
  INFORMATION: 'Informācija',
  SERVICE: 'Pakalpojums',
  STATUS: 'Statuss',
  EXTEND_TIME: 'Pagarināt laiku',
  TIME_EXTENDED: 'Laiks pagarināts!',
  NEW_CLIENTS_ONLY: 'Tikai jauniem klientiem',
  ONE_TIME_DISCOUNT: 'Vienreizēja atlaide',
  PAYMENT_METHOD_REQUIRED: 'Nepieciešams maksājuma veids',
  GENERATE_ONE_TIME_PROMO_CODES: 'Ģenerēt vienreizējus reklāmas kodus',
  ICON_FOR_APP: 'Ikona lietotnei',
  SELECT_CAMPAIGN: 'Izvēlieties kampaņu',
  WHICH_WILL_BE_VALID_FOR: 'Kas būs derīgs',
  AFTER: 'Pēc',
  DAYS: 'dienas',
  ACTIVATE: 'Aktivizēt',
  CREATE_NEW_CAMPAIGN: 'Izveidot jaunu kampaņu',
  ACTIVATE_NEW_CAMPAIGN: 'Aktivizēt jaunu kampaņu',
  PROMO_CODES: 'Reklāmas kodi',
  CREATE_NEW_PROMO_CODES: 'Izveidot jaunus reklāmas kodus',
  AMOUNT_OF_NEW_CODES: 'Jauno kodu skaits',
  DETAILS: 'Detalizēta informācija',
  COPY: 'Kopēt',
  RESET_PASSWORD: 'Atiestatīt paroli',
  COPY_PASSWORD_RESET_LINK: 'Kopēt paroles atiestatīšanas saiti',
  LOGIN_AS_THIS_USER: 'Pieteikties kā šis lietotājs',
  ACTIVE_SESSION: 'Aktīva sesija',
  ACTIVE_SESSIONS: 'Aktīvās sesijas',
  VERIFIED: 'Verificēts',
  LOCATIONS: 'Vietas',
  ZONES: 'Zonas',
  PLEASE_BE_PATIENT: 'Lūdzu, esiet pacietīgi...',
  SELECT_ZONE: 'Izvēlieties zonu',
  SELECT_PLACE: 'Izvēlieties vietu',
  FILTERS: 'Filtri',
  ADD_NEW_USER: 'Pievienot jaunu lietotāju',
  ADD_USER_SLASH_COMPANY: 'Pievienot lietotāju/uzņēmumu',
  EDIT_USER_SLASH_COMPANY: 'Rediģēt lietotāju/uzņēmumu',
  ACCESS_TO_PLATFORM: 'Piekļuve iespējota',
  CAN_VEW_PARKING_FINES: 'Var skatīt stāvvietas sodus',
  ENFORCEMENT_APP_ENABLED: 'Piespiedu lietotne aktivizēta',
  IS_NEW_TENANT: 'Izveidot nomnieku balto sarakstu',
  NAME_IS_REQUIRED: 'Vārds ir obligāts',
  EMAIL_IS_REQUIRED: 'E-pasts ir obligāts',
  IN_PLACES: 'Vietā',
  IN_ZONES: 'Zonā',
  EXPIRED: 'Beidzies',
  ACTIVE: 'Aktīvs',
  ACTIVE_PLURAL: 'Aktīvi',
  DOWNLOAD_TEMPLATE_FILE: 'Lejupielādēt veidnes failu',
  HOME: 'Sākums',
  TITLE: 'Nosaukums',
  MESSAGE: 'Ziņojums',
  SESSION: 'Sesija',
  COST_IN_EUROS: 'Izmaksas eiro',
  INVOICES: 'Rēķini',
  noDataText: 'Nav datu, ko parādīt',
  YES: 'Jā',
  NO: 'Nē',
  CANCEL: 'Atcelt',
  CAN_NOT_BE_UNDONE: 'Šo nevar atsaukt',
  SEARCH_BY_NAME: 'Meklēt pēc nosaukuma...',
  PREVIEW: 'Priekšskatījums',
  ARE_YOU_SURE: 'Vai esat pārliecināts?',
  COUNTRY_CODE: 'Valsts kods',
  LOADING_NEW_CONTENT: 'Ielādē jaunu saturu...',
  NEW_CONTENT_AVAILABLE: 'Jauns saturs pieejams. Lūdzu',
  REFRESH: 'ATJAUNOT',
  YEAR: 'Gads',
  MONTH: 'Mēnesis',
  EDIT: 'Rediģēt',
  ADD: 'Pievienot',
  DELETE: 'Dzēst',
  SAVE: 'Saglabāt',
  LOG_OUT: 'Izrakstīties',
  LOG_IN: 'Pieteikties',
  BACK: 'Atpakaļ',
  CLOSE: 'Aizvērt',
  LIST_EMPTY: 'Saraksts ir tukšs',
  PREVIOUS: 'Iepriekšējais',
  NEXT: 'Nākamais',
  PAGE: 'Lapa',
  SHOW: 'Parādīt',
  MONDAY: 'Pirmdiena',
  TUESDAY: 'Otrdiena',
  WEDNESDAY: 'Trešdiena',
  THURSDAY: 'Ceturtdiena',
  FRIDAY: 'Piektdiena',
  SATURDAY: 'Sestdiena',
  SUNDAY: 'Svētdiena',
  CURRENCY: 'Valūta',
  TOTAL: 'Kopā',
  COUNT: 'Skaits',
  VALID_FROM: 'Derīgs no',
  VALID_TO: 'Derīgs līdz',
  DESCRIPTION: 'Apraksts',
  IMPORT_FROM_FILE: 'Importēt no faila',
  INVITE_FROM_FILE: 'Uzaicināt no faila',
  SEARCH: 'Meklēt',
  EXPORT_TO_EXCEL: 'Eksportēt uz Excel',
  COMMENTS: 'Komentāri',
  CLIENT_ID: 'Klienta ID',
  PHONE_NUMBER: 'Telefona numurs',
  CAR_NUMBER: 'Automašīnas numurs',
  CLIENT_ACTIVE_CAR_NUMBER: 'Aktīvās automašīnas numurs',
  EMAIL: 'E-pasts',
  NAME: 'Vārds',
  LOCATION: 'Atrašanās vieta',
  START_TIME: 'Sākuma laiks',
  END_TIME: 'Beigu laiks',
  INVALID_DATE: 'Nederīgs datums',
  INVALID_TIME: 'Nederīgs laiks',
  COST: 'Izmaksas',
  TYPE: 'Tips',
  REGION: 'Reģions',
  ZONE: 'Zona',
  OPERATOR: 'Operators',
  GENERATE: 'Ģenerēt',
  SEND_TO_EMAIL: 'Sūtīt uz e-pastu',
  EMAIL_REQ_INFO: 'Reģistrācijas pieprasījuma saņemts ziņojums',
  EMAIL_REG_REQ_INFO:
    'E-pasta informācija, ja "Auto-apstiprināšana" ir izslēgta',
  CODE: 'Kods',
  ERROR_GLOBAL: 'Kaut kas nogāja greizi! Lūdzu, mēģiniet vēlreiz vēlāk.',
  COMMENTS_FOR_ENFORCEMENT: 'Komentāri izpildei',
  PARKING_ACTIVE: 'Stāvvieta aktīva',
  PARKING_NOT_ACTIVE: 'Stāvvieta nav aktīva',
  WITH_BOOKING: 'Ar rezervāciju',
  WITHOUT_BOOKING: 'Bez rezervācijas',
  PARKING_SESSIONS_OVER_FREE_TIME:
    'Stāvvietas sesijas pārsniedz bezmaksas laiku',
  EXTRA_FILTER: 'Papildu filtrs',
  HEADER: {
    LANGUAGE: 'Valoda'
  },
  EMPTY_STATE: {
    WHITELIST_EMPTY_HERE: 'Šeit ir tukšs',
    WHITELIST_EMPTY_HERE_MESSAGE: 'Jums nav neviena baltā saraksta',
    FLEETS_EMPTY_HERE: 'Šeit ir tukšs',
    FLEETS_EMPTY_HERE_MESSAGE: 'Jums nav nevienas flotes',
    USERS_EMPTY_HERE: 'Šeit ir tukšs',
    USERS_EMPTY_HERE_MESSAGE:
      'Jums nav neviena lietotāja vai jums nav tiesību rediģēt lietotājus',
    WHITELISTS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Norādītais transportlīdzeklis, šķiet, nepieder nevienam baltajam sarakstam',
    FLEETS_VEHICLE_NUMBER_SEARCH_NO_RESULTS:
      'Norādītais transportlīdzeklis, šķiet, nepieder nevienai flotei'
  },
  ALLOWED_TO_CALL: {
    TITLE: 'Baltais saraksts',
    PHONE_NUMBER: 'Telefona numurs',
    CAR_NUMBER: 'Automašīnas numurs',
    NAME: 'Vārds',
    APP: 'Pievienot lietotnei',
    VALID_UNTIL: 'Derīgs līdz',
    INVALID_INPUTS: 'Nepieciešams telefona numurs un automašīnas numurs',
    CALLS: 'Žurnāls',
    CHARGE_FOR_SESSIONS: 'Maksāt par sesijām'
  },
  DASHBOARD: {
    TITLE: 'Pārskats',
    DESCRIPTION: 'Visas aktīvās baltās saraksta un flotes sesijas',
    PLACES_TITLE: 'Jūsu atrašanās vietas',
    PLACES_DESCRIPTION: 'Visas vietas, kuras varat pārvaldīt.',
    ADDRESS: 'Adrese',
    THIS_MONTH_REVENUE: 'Šī mēneša ieņēmumi',
    LAST_MONTH_REVENUE: 'Pagājušā mēneša ieņēmumi',
    CHANGE_ALLOWED_TO_CALL: 'Baltais saraksts',
    SESSIONS_TITLE: 'Sesijas',
    SESSIONS_DESCRIPTION: 'Visas sesijas jūsu pārvaldītajās vietās.',
    GENERAL_FILTERS: 'Filtri',
    CAR_NUMBER: 'Automašīnas numurs',
    RESERVATION_TIME: 'Rezervācijas laiks',
    START_TIME: 'Sākuma laiks',
    END_TIME: 'Beigu laiks',
    STATUS: 'Statuss',
    COST: 'Izmaksas',
    CLIENT: 'Klients',
    CLIENTS_PHONE: 'Klienta tālrunis',
    CLIENTS_NAME: 'Klienta vārds',
    PLACE: 'Vieta',
    PAYMENT_INFO: 'Maksājuma informācija',
    PAID_WITH_MONTHLY_PASS: 'Apmaksāts ar mēneša abonementu',
    PAID_WITH_CREDITCARD: 'Apmaksāts ar kredītkarti',
    WHITELISTED: 'Baltajā sarakstā',
    PLACE_NAME: 'Atrašanās vieta',
    SEARCH: 'Meklēt',
    UTILIZATION: 'Noslodze',
    PAYMENT_FROM: 'No',
    PAYMENT_TO: 'Līdz',
    SUMMARY: 'Kopsavilkums',
    REVENUE: 'Ieņēmumi',
    MONTHLY_PASSES_REVENUE: 'Mēneša abonementi',
    OWNERS_SHARE: 'Īpašnieka daļa',
    PHONE_CALL: 'Tālruņa zvans',
    RFID: 'RFID',
    INVOICE: 'Rēķins',
    PAYMENT_LOGS: 'Maksājumu žurnāli',
    CREDIT: 'Kredīts',
    WHITELISTS: 'Baltie saraksti',
    FLEETS: 'Flotes',
    CAMPAIGNS: 'Kampaņas',
    CAMPAIGN_CODE: 'Kampaņas kods',
    REG_LIMIT: 'Reģ. limits',
    REGISTRANTS: 'Reģistrētie',
    NO_ACTIVE_CAMPAIGNS: 'Nav aktīvu kampaņu',
    PAYOUTS: 'Izmaksas',
    USERS: 'Lietotāji',
    USERS_DESCRIPTION: 'Visi lietotāji, kurus varat pārvaldīt',
    CAMPAIGN_DESCRIPTION: 'Visas kampaņas',
    START_SESSION: 'Sākt stāvvietu',
    REPORTS: 'Atskaites',
    TYPES: 'Tips:',
    REGIONS: 'Reģions:',
    ZONES: 'Zona:',
    OPERATORS: 'Operators:',
    IMPORT_FROM_FILE: 'Importēt no faila',
    ADD_NEW_LOCATION: 'Pievienot jaunu vietu',
    CONTROLLER: 'Kontrolieris',
    STATISTICS: 'Statistika',
    MONTHLY_PASSES: 'Mēneša abonementi',
    WHITELIST: 'Baltais saraksts',
    EVENTS: 'Notikumi',
    LPR: 'LPR',
    DEAL_TIMELOG: 'Darījumu laika žurnāls',
    SETTINGS: 'Iestatījumi',
    SETTINGS_DESCRIPTION: 'Visi iestatījumi',
    DAY_PASSES: 'Iebraukšanas caurlaides',
    BOOKING: 'Rezervācija',
    KIOSKS: 'Kioski'
  },
  CONTROLLERS: {
    REFRESH: 'Atsvaidzināt',
    CONTROLLER_LOGS: 'Kontroliera žurnāli',
    FIRMWARE: 'Programmatūra',
    FIRMWARE_UPDATE: 'Programmatūras atjauninājums',
    UPDATE_FIRMWARE: 'Atjaunināt programmatūru',
    FIRMWARE_VERSION: 'Programmatūras versija',
    FIRMWARE_VERSION_INFORMATION_TITLE:
      'Informācija par programmatūras versiju',
    VERSION: 'Versija',
    REASON: 'Iemesls',
    OTA_NOTIFICATION_DESCRIPTION:
      'Pašlaik nav iespējams atjaunināt programmatūru bezvadu režīmā, ja versija sākas ar 1.1.',
    CLOSED: 'AIZVĒRTS',
    OPENED: 'ATVĒRTS',
    ADD_CONTROLLER: 'Pievienot kontrolieri',
    EDIT_CONTROLLER: 'Rediģēt kontrolieri'
  },
  EDIT_PLACE: {
    SCHEDULE_VALIDITY: {
      TITLE: 'Grafika derīgums',
      FROM: 'No',
      TO: 'Līdz',
      UNLIMITED: 'Neierobežots'
    },
    RENTAL_SCHEDULE: {
      TITLE: 'Nomāšanas grafiks',
      COPY_MONDAY_SCHEDULE: 'Kopēt pirmdienas grafiku uz visām dienām',
      SPOTS: 'vietas',
      OTHER_TIMES: 'Citi laiki',
      IS_CLOSED: 'Slēgts'
    },
    MONTHLY: {
      TITLE: 'Mēneša abonementi',
      ENABLED: 'Aktivizēts',
      MONTHLY_COST: 'Mēneša izmaksas',
      MAX_NUM: 'Maksimālais pieejamais',
      NOTIFICATION_EMAILS: 'Paziņojumu e-pasti',
      DESCRIPTION_FOR_APP: 'Apraksts lietotnei',
      NO_ACTIVE_MONTHLY_PASSES: 'Nav aktīvu mēneša abonementu',
      NO_EXPIRED_MONTHLY_PASSES: 'Nav beigušos mēneša abonementu',
      UPDATED: 'Mēneša abonements veiksmīgi atjaunināts',
      ADDED: 'Mēneša abonements veiksmīgi pievienots'
    }
  },
  LOGIN: {
    EMAIL: 'E-pasts',
    PASSWORD: 'Parole',
    INVALID_INPUTS: 'Nederīgs e-pasts vai parole.',
    FORGOT_PASSWORD: 'Aizmirsāt paroli?',
    FORGOT_PASSWORD_TITLE: 'Aizmirsāt paroli',
    SUBMIT: 'Iesniegt'
  },
  REGISTER: {
    REGISTER: 'Reģistrēties',
    NAME: 'Vārds',
    EMAIL: 'E-pasts',
    PHONE_NUMBER: 'Tālruņa numurs',
    PASSWORD: 'Parole',
    PASSWORD_AGAIN: 'Parole vēlreiz'
  },
  STATISTICS: {
    TITLE: 'Statistika',
    SHOW: 'Rādīt',
    SHOW_LOG: 'Rādīt žurnālu',
    FROM: 'No',
    TO: 'Līdz',
    WITH_APP: 'Ar lietotni',
    WITHOUT_APP: 'Bez lietotnes',
    TOTAL_SESSIONS: 'Kopējais sesiju skaits',
    TIMESTAMP: 'Laika zīmogs',
    EVENT: 'Notikums',
    SESSIONS_PER_DAY: 'Stāvvietas sesijas dienā',
    TIME_OF_DAY: 'Dienas laiks',
    PARKING_SESSIONS: 'Stāvvietas sesijas',
    GROUP_BY_CAR: 'Grupēt pēc auto nr.',
    SELF_PAID_PARKING_SESSIONS: 'Pašapmaksātās stāvvietas sesijas'
  },
  WHITELISTS: {
    TITLE: 'Baltie saraksti',
    REGION: 'Reģions',
    NAME: 'Vārds',
    VALID_IN: 'Derīgs',
    APPROVED_USERS: 'Apstiprinātie lietotāji',
    PENDING_USERS: 'Gaidītie lietotāji',
    ADD_NEW: 'Pievienot jaunu',
    WITH_AVAILABILITY_INFO: 'Ar pieejamības informāciju',
    ACTIVE_USERS: 'Aktīvie lietotāji',
    INACTIVE_USERS: 'Neaktīvie lietotāji'
  },
  EDIT_WHITELISTS: {
    ADD_NEW_WHITELIST: 'Pievienot jaunu baltu sarakstu',
    EDIT_WHITELIST: 'Rediģēt baltu sarakstu',
    DETAILS: 'Detaļas',
    USERS: 'Lietotāji',
    SESSIONS: 'Sesijas',
    NAME: 'Vārds',
    APP: 'Lietotne',
    REGION: 'Reģions',
    VALID_IN: 'Derīgs',
    REGISTRATION_ALLOWED_UNTIL: 'Reģistrācija atļauta līdz',
    REG_CODE_FOR_APP: 'Reģ. kods lietotnē',
    AUTO_APPROVE: 'Automātiski apstiprināt lietotājus',
    ONE_TIME_CODES: 'Vienreizēji promocijas kodi',
    REG_NOTIFICATION_EMAILS: 'E-pasts paziņojumiem',
    ADD_MANAGER: 'Pievienot vadītāju',
    PUBLIC_REG_LINK: 'Publiska reģistrācijas saite',
    MANAGERS: 'Vadītāji',
    NO_MANAGERS: 'Nav aktīvu vadītāju',
    CHARGE_FOR_SESSIONS: 'Maksāt par sesijām',
    START_SESSIONS_WITH_LPR: 'Sākt sesiju ar LPR',
    START_SESSIONS_WITH_LPR_DESCRIPTION:
      'Sesija sākas automātiski, ja ir uzstādīts automātiskās numura zīmju atpazīšanas sistēma.',
    AVAILABILITY_AND_PRICING: 'Pieejamība un cenas',
    MANAGE_AVAILABILIY_AND_PRICING: 'Pārvaldīt pieejamību un cenas',
    EMAIL_INFO_AFTER_APPROVAL: 'E-pasta saturs pēc veiksmīgas reģistrācijas',
    WHITELIST_USERS: 'Baltā saraksta lietotāji',
    INVITE: 'Sūtīt ielūgumu',
    ADD_NEW: 'Pievienot jaunu',
    PHONE_NUMBER: 'Tālruņa numurs',
    CAR_NUMBERS: 'Numura zīmes',
    USER_NAME: 'Vārds',
    EMAIL: 'E-pasts',
    REG_TYPE: 'Reģ. veids',
    REG_TIME: 'Reģistrācijas laiks',
    COMMENTS: 'Komentāri',
    STATUS: 'Statuss',
    ACTIVE_SESSIONS: 'Aktīvās sesijas',
    SESSION_ID: 'Sesijas ID',
    LOCATION: 'Atrašanās vieta',
    CAR_NUMBER: 'Numura zīme',
    START_TIME: 'Sākuma laiks',
    END_TIME: 'Beigu laiks',
    OVERTIME_MINUTES: 'Pārsniegtie laika minūtes',
    OVER_ALLOWED_SPOTS_LIMIT_MINUTES:
      'Pārsniegtie minūtes virs atļautā vietu ierobežojuma',
    OVER_ALLOWED_SPOTS_LIMIT_NUMBER_OF_PARKING_SESSIONS:
      'Stāvvietas sesiju skaits virs atļautā vietu ierobežojuma',
    REPORT: 'Ziņojums',
    TYPE: 'Ziņojuma veids',
    SESSIONS_COUNT: 'Sesiju skaits',
    PARKED_MINUTES: 'Stāvēšanas minūtes',
    COST: 'Cena',
    NO_ACTIVE_SESSIONS: 'Nav aktīvu sesiju',
    SELECT_WHITELIST: 'Izvēlēties baltu sarakstu',
    MAX_NUMBER_OF_VEHICLES: 'Maksimālais lietotāju/vadītāju skaits',
    DEFAULT_MAX_NUMBER_OF_VEHICLES_FOR_REGISTERED_CLIENT:
      'Pamatmaksimālais transportlīdzekļu skaits reģistrētajam klientam',
    PLACE_REQUIRED: 'Ja "Derīgs" ir "Vieta", jāizvēlas vismaz 1 vieta',
    ZONE_REQUIRED: 'Ja "Derīgs" ir "Zona", jāizvēlas vismaz 1 zona',
    MAX_NUMBER_OF_USER_VEHICLES: 'Maksimālais transportlīdzekļu skaits',
    USE_OWN_AVAILABILITY_AND_PRICING: 'Izmantot īpašu pieejamību un cenas',
    ALLOW_PARKING_WITH_NO_SPOTS: 'Atļaut stāvēšanu bez vietām',
    ADD_TO_FAVORITES: 'Pievienot pie favorītiem',
    REMOVE_FROM_FAVORITES: 'Noņemt no favorītiem',
    ADDED_TO_FAVORITES: 'Baltais saraksts pievienots izlasei',
    REMOVED_FROM_FAVORITES: 'Baltais saraksts noņemts no izlasei.',
    EXPIRATION_WARNING_TITLE: 'Tas ietekmēs {0} lietotājus',
    EXPIRATION_WARNING_TITLE_ONE: 'Tas ietekmēs 1 lietotāju',
    EXPIRATION_WARNING_BODY:
      'Dažiem lietotājiem pašlaik ir vēlāks derīguma termiņš nekā lietotāju grupai. Viņu piekļuve beigsies {0}, ja grupas derīguma termiņš netiks pagarināts.'
  },
  AVAILABILITY_TABLE: {
    TITLE: 'Pieejamība un cenas',
    SUB_TITLE: '',
    '24H_COST': '24h cena',
    OTHER_TIMES: 'Citi laiki',
    NUMBER_OF_SPOTS: 'Vietu skaits',
    HOURLY_RATE: 'Stundas likme',
    MIN_COST: 'Minimālā cena',
    MAX_COST: 'Maksimālā cena'
  },
  FLEETS: {
    TITLE: 'Autoparki',
    ADD_NEW: 'Pievienot jaunu',
    REGION: 'Reģions',
    NAME: 'Vārds',
    TYPE: 'Veids',
    REG_CODE: 'Reģ. kods',
    USERS_LIMIT: 'Atļautais lietotāju limits',
    USERS: 'Lietotāji',
    REPORT: 'Ziņojumi',
    DEFAULT_MINUTES_INFORMATION:
      'Izvēlētajā vietā ir iestatītas noklusētās stāvvietas minūtes:'
  },
  EDIT_FLEETS: {
    TITLE: 'Autoparki',
    NAME: 'Vārds',
    TYPE: 'Veids',
    REGION: 'Reģions',
    VALID_IN: 'Derīgs',
    APP: 'Lietotne',
    DEF_DAILY_LIMIT: 'Noklusētais ikdienas limits',
    DEF_MONTHLY_LIMIT: 'Noklusētais mēneša limits',
    MAX_NUMBER_OF_USERS: 'Maksimālais lietotāju limits',
    RESET_LIMITS: 'Atiestatīt limitus mēneša sākumā',
    REG_OPEN_TIL: 'Reģistrācija atļauta līdz',
    REG_CODE_APP: 'Aktivizācijas kods lietotnē',
    AUTO_APPROVE: 'Automātiski apstiprināt lietotājus',
    ONE_TIME_PROMO_CODES: 'Vienreizēji promo kodi lietotnē',
    REG_NOTIFICATION_EMAIL: 'E-pasts paziņojumiem',
    PUBLIC_REG_LINK: 'Publiskā reģistrācijas saite',
    START_WITH_LPR: 'Sākt sesiju ar LPR',
    ADD_MANAGER: 'Pievienot vadītāju',
    MANAGERS: 'Vadītāji',
    NO_MANAGERS: 'Nav vadītāju',
    EMAIL_BODY_AFTER_REGISTRATION:
      'E-pasta saturs pēc veiksmīgas reģistrācijas',
    DESC_FOR_APP: 'Apraksts lietotnei',
    PHONE_NUMBER: 'Tālruņa numurs',
    CAR_NUMBER: 'Numura zīme',
    USER_NAME: 'Vārds',
    EMAIL: 'E-pasts',
    DAILY_LIMIT: 'Ikdienas limits',
    MONTHLY_LIMIT: 'Mēneša limits',
    REG_TYPE: 'Reģ. veids',
    REG_TIME: 'Reģistrācijas laiks',
    STATUS: 'Statuss',
    INVITE: 'Sūtīt ielūgumu',
    ADD_NEW: 'Pievienot jaunu',
    FLEET_USERS: 'Lietotāji',
    SELECT_FLEET: 'Izvēlēties autoparku',
    ADD_NEW_FLEET: 'Pievienot jaunu autoparku',
    EDIT_FLEET: 'Rediģēt autoparku',
    PLACE_REQUIRED: 'Ja "Derīgs" ir "Vieta", jāizvēlas vismaz 1 vieta',
    ZONE_REQUIRED: 'Ja "Derīgs" ir "Zona", jāizvēlas vismaz 1 zona'
  },
  FLEET_REPORT: {
    LIMIT: 'Mēneša limits:',
    USED_TOTAL: 'Izmantots:',
    DAILY_LIMIT: 'Ikdienas limits',
    MONTHLY_LIMIT: 'Mēneša limits',
    USED_FLEET_CREDIT: 'Izmantotais kredīts',
    AVAILABLE_FLEET_CREDIT: 'Pieejamais kredīts',
    OVER_LIMIT: 'Pārsniegts limits',
    SELF_PAID: 'Pašapmaksāts'
  },
  REPORTS: {
    TITLE: 'Ziņojumi',
    DESCRIPTION: 'Visi ziņojumi',
    REPORT_TYPE: 'Ziņojuma veids',
    GROUP_BY: 'Grupēt pēc'
  },
  ADD_SESSION: {
    TITLE: 'Pievienot sesiju',
    HOURS: 'Stundas',
    DAYS: 'Dienas',
    MINUTES: 'Minūtes'
  },
  ENFORCEMENT: {
    ENFORCER: 'Izpildītājs',
    ENFORCEMENT: 'Izpilde',
    REASON: 'Iemesls',
    ADDITIONAL_REASON_CODE: 'Papildu iemesls (kods)',
    ADDITIONAL_REASON_TEXT: 'Papildu iemesls (teksts)',
    CREATED_AT: 'Izsniegts',
    LOOK_IMAGES: 'Skatīt attēlus',
    MARK_AS_PAID: 'Atzīmēt sodu kā samaksātu',
    CANCEL_FINE: 'Atcelt sodu',
    FINE_PAYMENT_DATE: 'Samaksas saņemšanas datums',
    NO_IMAGES_TO_SHOW: 'Nav attēlu (attēli netika uzņemti)',
    PAID_AMOUNT: 'Samaksātā summa',
    OVERDUE: 'Aizkavēts',
    EDIT_PARKING_FINE: 'Rediģēt stāvvietas sodu',
    VEHICLE_NUMBER_COUNTRY: 'Reģistrācijas valsts',
    LOCATION: 'Atrašanās vieta',
    ISSUER_NAME: 'Izpildītājs',
    PARKING_FINES: 'Stāvvietas sodi',
    PAYMENT_DATE_REQUIRED: 'Nepieciešams samaksas datums',
    PAID_AMOUNT_REQUIRED: 'Nepieciešama samaksātā summa',
    DEBTS_SENT: 'Parādi nosūtīti',
    DEBTS_SENT_YES: 'JĀ',
    DEBTS_SENT_NO: 'NĒ',
    DEBT_INCOMES: 'Ieņēmumi',
    AMOUNT_RECEIVED: 'Saņemta summa',
    RECEIVED_INCOME_DATE: 'Ieņēmumu saņemšanas datums',
    MARK_RECEIVED_INCOME: 'Atzīmēt ieņēmumus',
    INCOMES: 'Ieņēmumi',
    DOWNLOAD_PARKING_FINE_PDF: 'Lejupielādēt PDF',
    ID: 'ID',
    VOID_TIME: 'Atcelšanas laiks',
    PARKING_FINE: 'Stāvvietas sods',
    ALSO_CREATE_NEW_FINE: 'Izveidot jaunu stāvvietas sodu',
    LAST_AMOUNT: 'Pēdējā summa',
    PARKING_FINE_INVOICES: 'Rēķini',
    PARKING_FINE_INVOICE_NUMBER: 'Numurs',
    PARKING_FINE_INVOICE_DATE: 'Datums',
    PARKING_FINE_AMOUNT: 'Summa',
    COMMENTS: 'Komentāri',
    COMMENT: 'Komentārs',
    NO_COMMENTS: 'Nav komentāru...',
    REFERENCE_NUMBER: 'Atsauces numurs',
    PARKING_FINE_PROFILE_BENEFICIARY: 'Labuma guvējs',
    SEND_FINE_TO_JULIANUS: 'Nosūtīt uz Julianus',
    RESET_PARKING_FINE: 'Atiestatīt stāvvietas sodu',
    DO_NOT_FORWARD_DEBTS: 'Nenosūtīt parādus',
    HAS_SENT_APPEAL: 'Sūdzība iesniegta',
    PARKING_FINE_UPDATED_SUCCESSFULLY: 'Stāvvietas sods veiksmīgi atjaunināts',
    DEBTS_WILL_BE_FORWARDED_AT: 'Parādi tiks nosūtīti līdz:',
    PARKING_STATUS_CHECK_LOGS: 'Numura zīmju pārbaudes',
    CHECKED_AT: 'Pārbaudīts',
    HAD_PARKING: 'Stāvvieta',
    INCOME_RECEIVED_VIA_CHANNEL: 'Kanāls',
    INCOME_INSERTER: 'Ievadītājs',
    INCOME_RECEIVED_AT: 'Saņemta summa',
    FORWARD_DEBTS_AT: 'Nosūtīt parādus līdz',
    COMMENTS_REQUIRED: 'Nepieciešams komentārs',
    PARKING_FINE_REPORTS: {
      TITLE: 'Automatizētie ziņojumi',
      EDIT: 'Rediģēt',
      ADD_NEW: 'Pievienot jaunu',
      EMAIL_TO: 'E-pasta adrese(s)',
      EMAIL_BCC: 'E-pasta BCC adrese(s)',
      SENDING_DAYS: 'Dienas, kad ģenerēt/sūtīt',
      IS_MONTHLY_REPORTING_ENABLED: 'Ziņošana ieslēgta',
      NEW_VEHICLE_GROUP_NAME: 'Jauna grupas nosaukums',
      NEW_VEHICLE_GROUP_NAME_IS_REQUIRED:
        'Jauna transportlīdzekļa grupas nosaukums ir nepieciešams',
      VEHICLE_LIST: 'Transportlīdzekļu saraksts',
      NEW_TASK_ADDED_SUCCESSFULLY:
        'Jauns ziņošanas uzdevums veiksmīgi izveidots'
    },
    ENFORCEMENT_OFFICERS: {
      TITLE: 'Enforcement officers',
      ADD_NEW_OFFICER: 'Add new enforcer',
      EDIT_OFFICER: 'Edit enforcer info',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      OFFICER_NAME: 'Name',
      GROUP: 'Group'
    },
    PARKING_FINE_PLATFORM_URL: 'Saite uz stāvvietas sodu platformu',
    PENALTY_APPEAL_COMMENTS: 'Soda apstrīdēšanas komentāri',
    PENALTY_APPEAL_COMMENTS_ADD: 'Pievienot soda apstrīdēšanas komentārus',
    COMMENTS_TOO_LONG: 'Komentāri nedrīkst būt garāki par 1024 rakstzīmēm',
    REGION: 'Reģions'
  },
  SETTINGS: {
    OPERATOR_SETTINGS: 'Operatora iestatījumi',
    OPERATOR_SETTINGS_DESCRIPTION: 'Visi operatora iestatījumi',
    ADD_NEW_ZONE: 'Pievienot jaunu zonu',
    NO_ZONES: 'Nav zonu',
    CHOOSE_ICON: 'Izvēlieties ikonu',
    ZONE_UPDATED: 'Zona veiksmīgi atjaunināta!',
    NEW_ZONE_ADDED: 'Jauna zona veiksmīgi pievienota!',
    EDIT_ZONE: 'Rediģēt zonu'
  },
  ENTER_PASSWORD: 'Ievadiet paroli',
  REPEAT_PASSWORD: 'Atkārtojiet paroli',
  ACTIVATE_ACCOUT: 'Aktivizējiet savu kontu',
  PASSWORD_CRITERIA_MISMATCH:
    'Parolei jābūt vismaz 8 rakstzīmēm, 1 skaitlim un 1 lielajai burtam',
  ACCOUNT_ACTIVATED_SUCCESSFULLY:
    'Konts aktivizēts! Izmantojiet savu jauno paroli, lai pieteiktos',
  AUTO_GENERATE_PASSWORD: 'Automātiski ģenerēt paroli',
  PROFILE: 'Profils',
  SEND_OWNER_INVITE: 'Nosūtīt uzaicinājumu',
  UPDATE_PASSWORD: 'Atjaunināt paroli',
  SEARCH_BY_VEHICLE: 'Meklēt pēc transportlīdzekļa numura',
  BOOKING: {
    CAR_NUMBER: 'Auto',
    START_TIME: 'Sākuma laiks',
    END_TIME: 'Beigu laiks',
    NAME: 'Vārds',
    PHONE_NUMBER: 'Tālruņa numurs',
    EMAIL: 'E-pasts',
    COMMENTS: 'Komentārs',
    SEARCH_TITLE: 'Rezervāciju meklēšana',
    CLIENT: 'Klients',
    EDIT_BOOKING: 'Rediģēt rezervāciju',
    DELETE_BOOKING: 'Dzēst rezervāciju',
    ADD_NEW: 'Pievienot jaunu rezervāciju',
    STATUS: 'Statuss',
    EXTERNAL_BOOKING_NUMBER: 'Ārējais rezervācijas numurs',
    DATE_PLACEHOLDER: '31-12-2099',
    TIME_PLACEHOLDER: '23:59',
    START_DATE: 'Sākuma datums',
    END_DATE: 'Beigu datums',
    PARKING_STATUS_PARKING: 'Stāvvieta',
    PARKING_STATUS_NOT_PARKING: 'Nav stāvvietā',
    CAR_IS_REQUIRED: 'Auto ir obligāts',
    TIME_FORMAT_INCORRECT: 'Laika formātam jābūt HH:MM',
    DATE_FORMAT_INCORRECT: 'Datuma formātam jābūt 31.01.2024',
    END_BOOKING: 'Beigt rezervāciju',
    END_BOOKING_DESCRIPTION:
      'Jūs gatavojaties beigt rezervāciju, vai esat pārliecināts, ka vēlaties to beigt?',
    PUT_SUCCESSFUL: 'Rezervācija veiksmīgi atjaunināta',
    ADD_BOOKING: 'Pievienot rezervāciju',
    POST_SUCCESSFUL: 'Rezervācija veiksmīgi pievienota',
    PARKING_ACTIVE: 'Stāvvieta aktīva',
    PARKING_NOT_ACTIVE: 'Stāvvieta nav aktīva',
    STARTING_BOOKINGS: 'Sākot rezervācijas',
    OCCUPANCY_CALENDAR: 'noslogojuma kalendārs',
    ACTIVE_PARKINGS_CURRENTLY: 'Šobrīd aktīvas stāvvietas',
    COST: 'Izmaksas',
    CREATED_AT: 'izveidots plkst.'
  },
  QUICK_ACTIONS: {
    TOOLTIP: 'Ātrās darbības',
    COMMAND_SENT: 'Komanda nosūtīta',
    COMMAND_FAILED: 'Komanda neizdevās'
  },
  EDIT_SESSION: 'Rediģēt sesiju',
  DELETE_SESSION: 'Beigt sesiju',
  SET_CURRENT_END_TIMESTAMP: 'Iestatīt beigu laika zīmogu uz pašreizējo',
  AUTOMATIC_PAY_AFTER_SAVE: 'Aprēķināt izmaksas automātiski',
  MAKE_PAYMENT_AFTER_SAVE: 'Uzsākt maksājumu pēc saglabāšanas',
  SESSION_WITH_BOOKING: 'Sesija ar rezervāciju',
  SEARCH_BY_NAME_OR_EMAIL: 'Meklēt pēc vārda vai e-pasta',
  VEHICLE_GROUPS: {
    TITLE: 'Transportlīdzekļu grupas',
    GROUP_NAME: 'Grupas nosaukums',
    ADD_NEW: 'Pievienot jaunu',
    EDIT: 'Rediģēt',
    PUT_SUCCESSFUL: 'Veiksmīgi mainīts',
    POST_SUCCESSFUL: 'Veiksmīgi pievienots',
    LICENSE_PLATES: 'Reģistrācijas numuri',
    LICENSE_PLATE: 'Reģistrācijas numurs',
    LICENSE_PLATES_POST_SUCCESSFUL: 'Saraksts veiksmīgi atjaunināts',
    LICENSE_PLATE_IMPORT_WARNING_MESSAGE:
      'Jūs gatavojaties importēt šos reģistrācijas numurus:',
    DELETE_SUCCESSFUL: 'Dzēšana veiksmīga',
    LICENSE_PLATE_DELETE_WARNING_MESSAGE:
      'Jūs gatavojaties dzēst reģistrācijas numuru:',
    ENTER_NEW_LICENSE_PLATE:
      'Ievadiet jaunu transportlīdzekļa reģistrācijas numuru formātā 123ABC',
    REMOVE_EXISTING_VEHICLES: 'Noņemt esošos transportlīdzekļus'
  },
  ADD_NEW: 'Pievienot jaunu',
  CAR_WASH_DISPUTES: {
    TITLE: 'Strīdi',
    CREATED_AT: 'Izveidots',
    LICENSE_PLATE: 'Reģistrācijas numurs',
    STATUS: 'Statuss',
    EDIT_DISPUTE: 'Rediģēt',
    SERVICE_TIME: 'Servisa laiks',
    EDIT: 'Rediģēt strīdu',
    AMOUNT: 'Summa',
    MESSAGE: 'Ziņa',
    REJECT: 'Noraidīt',
    APPROVE: 'Apstiprināt',
    ALL_DISPUTES: 'Visi strīdi',
    PLACE_NAME: 'Vietas nosaukums',
    SERVICE_NAME: 'Servisa nosaukums'
  },
  SEARCH_BY_PLACE_FLEET_OR_WHITELIST_NAME:
    'Vieta, flote vai baltā saraksta nosaukums',
  PRICE: 'Cena',
  FROM_PREVIOUS_MONTH_START: 'No iepriekšējā mēneša',
  PREVIOUS_MONTH: 'Iepriekšējais mēnesis',
  CURRENT_MONTH: 'Šis mēnesis',
  PREVIOUS_WEEK: 'Iepriekšējā nedēļa',
  CURRENT_WEEK: 'Šī nedēļa',
  YESTERDAY: 'Vakar',
  TODAY: 'Šodien',
  LAST_7_DAYS: 'Pēdējās 7 dienas',
  PARKED_MINUTES: 'Stāvēšanas minūtes',
  OVERTIME_MINUTES: 'Papildlaiks minūtēs',
  GATE_CONTROLLERS: {
    ADD_NEW: 'Lisa uus',
    ACTIONS: 'Darbības',
    RESTART: 'Restartēt',
    PIN_STATES: 'Pin stāvokļi',
    OUTPUT_PIN_STATES: 'Izvades tapu stāvokļi',
    LAST_HEARTBEAT: 'Pēdējie sirdspuksti',
    SIGNAL_STRENGTH: 'Signāla stiprums',
    OPEN: 'Atvērt'
  }
}
